import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import WarningIcon from '@material-ui/icons/Warning';

export class MissingWorkerProperties extends Component {
  static propTypes = {
    missingProperties: PropTypes.array.isRequired,
    workerIds: PropTypes.array.isRequired,
    workers: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    console.log({mp: this.props.missingProperties, wids: this.props.workerIds, ws: this.props.workers});
    if (!this.props.missingProperties || !this.props.workerIds || !this.props.workers)
      return null;
    return (
      <div className="home-missing-worker-properties">
        {this.props.missingProperties.filter(mp => this.props.workerIds.includes(mp.workerId)).map(mp => <div><WarningIcon /><a href={"/worker-config/"+mp.workerId} target={"blank"}>{this.props.workers[mp.workerId].name}</a> {mp.kind === "Missing" ? "benötigt" : "hat unerwartet"}{" "}{mp.badRoles.join(",")}</div>)}
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    missingProperties: state.home.missingProperties,
    workers: state.home.workers,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MissingWorkerProperties);



// WEBPACK FOOTER //
// ./src/features/home/MissingWorkerProperties.js